import { HiOutlineArrowRight } from "react-icons/hi2";
import styled, { css } from "styled-components";
import { useChat } from "../context/ChatContext";
import { NavLink } from "react-router-dom";

const StyledOptimizedQuestion = styled.div`
  width: 33%;

  @media only screen and (max-width: 425px) {
    width: 70%;
  }
`;

const Question = styled.div`
  min-height: 9rem;
  padding: 1rem;
  border-top-right-radius: 1.5rem;
  border-top-left-radius: 1.5rem;

  color: var(--use-case-text);
  background-color: var(--use-case-background);

  ${(props) =>
    props.type === "primary" &&
    css`
      border: 1px solid var(--use-case-primary);
    `}

  ${(props) =>
    props.type === "secondary" &&
    css`
      border: 1px solid var(--use-case-secondary);
    `}

    ${(props) =>
    props.type === "tertiary" &&
    css`
      border: 1px solid var(--use-case-tertiary);
    `}
`;

const Ask = styled(NavLink)`
  width: 100%;
  border: none;
  padding: 0.5rem;
  border-bottom-left-radius: 1.5rem;
  border-bottom-right-radius: 1.5rem;
  text-align: end;
  min-height: 3rem;
  color: var(--ask-color);

  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;

  ${(props) =>
    props.type === "primary" &&
    css`
      background-color: var(--use-case-primary);
    `}

  ${(props) =>
    props.type === "secondary" &&
    css`
      background-color: var(--use-case-secondary);
    `}

    ${(props) =>
    props.type === "tertiary" &&
    css`
      background-color: var(--use-case-tertiary);
    `}
`;

function renderWithItalics(text) {
  return text.split(/(\*[^*]+\*)/).map((part, i) =>
    part.length > 2 && part.startsWith("*") && part.endsWith("*")
      ? <i key={i}>{part.slice(1, -1)}</i>
      : part
  );
}

function OptimizedQuestion({ question, label, type }) {
  const { setQuestion, ask } = useChat();

  return (
    <StyledOptimizedQuestion>
      <Question type={type}>{renderWithItalics(label)}</Question>
      <Ask
        type={type}
        to="/chat"
        onClick={() => {
          setQuestion(question);
          ask({ useCaseQuestion: question });
        }}
      >
        Ask
        <HiOutlineArrowRight />
      </Ask>
    </StyledOptimizedQuestion>
  );
}

export default OptimizedQuestion;
